import { ACTION_TYPE, Action, ActionPersistData, ElementToUpdate, OperationType } from "../action.model";
import { AddToArrayValue, OpAddToArray } from "./opAddToArray";

export class OpRemoveFromArray<ElementTypes, TypeName extends keyof ElementTypes, ElementType extends ElementTypes[TypeName], AppLogInfos, Context> extends OpAddToArray<ElementTypes, TypeName, ElementType, AppLogInfos, Context> {

    // TODO comment
    constructor(protected override readonly _elementTypeName: TypeName,
        protected override _elementToUpdate: ElementType,
        protected override readonly _field: keyof ElementTypes[TypeName],
        protected _objectToRemove: AddToArrayValue,
        protected override _index?: number) {
        super(_elementTypeName, _elementToUpdate, _field, _objectToRemove, _index);
    }

    /**
     * Add element to array
     */
    public override process(action: Action<ElementTypes, AppLogInfos, Context>): void {
        super.undo(action);
    }

    /**
     * Remove element from array
     */
    public override undo(action: Action<ElementTypes, AppLogInfos, Context>): void {
        super.process(action);
    }

    /**
     * Returns the type of the current Operation
     * @returns {OperationType}
     */
    public override getOperationType(): OperationType {
        return OperationType.REMOVE;
    }

    /**
     * Get _objectToRemove
     */
    public getObjectToRemove(): AddToArrayValue {
        return this._objectToRemove;
    }

    /**
     * Action to string
     * @param action 
     * @returns {string}
     */
    public override toString(action: Action<ElementTypes, AppLogInfos, Context>): string {
        return `Remove ${this._getObjectToAdd()} from ${String(this._elementTypeName)}.${String(this._field)}`;
    }

    /**
     * Add server server action element to ActionPersistenceData
     */
    public override addServerActionElement(actionPersistenceData: ActionPersistData<Context>, params: { elementsToUpdateByTypeAndId: Record<string, ElementToUpdate>, action: Action<ElementTypes, AppLogInfos, Context>, actionType: ACTION_TYPE }): void {
        return this._addServerActionElement(actionPersistenceData, {
            action: params.action, actionType: params.actionType, elementsToUpdateByTypeAndId: params.elementsToUpdateByTypeAndId,
            operation: params.actionType === ACTION_TYPE.UNDO ? "add" : "remove"
        });
    }
}